import { useState } from "react";
import { Loading } from "components/assets/Icons";
import Button, { SIZE as VIEW, COLOR } from "components/Button";
import styles from "./Modals.module.scss";
import DropdownMenu from "../AddPage/components/DropdownMenu";
import userProfile from "services/user.profile";
import { dataBreaks } from "./dataBreaks";

export const ModalAddBreak = ({
  setShowModal,
  setInfoMessage,
  setShowInfoMessage,
  setTypeOfMessage,
}) => {
  const [selectedMinDuration, setSelectedMinDuration] = useState("");
  const [selectedMaxDuration, setSelectedMaxDuration] = useState("");
  const [loading, setLoading] = useState(false);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const newBreak = {
      min_duration: selectedMinDuration,
      max_duration: selectedMaxDuration,
    };

    const addNewBreak = async (newBreak) => {
      try {
        const response = await userProfile.addBreak(newBreak);

        if (response.status === 201) {
          setTypeOfMessage("success");
          setInfoMessage("Break added successfully");
          setTimeout(() => setShowInfoMessage(true), 900);
          setTimeout(() => setShowInfoMessage(false), 2900);
        }
      } catch (error) {
        console.error("error >>:", error);
      } finally {
        setLoading(false);
      }
    };
    addNewBreak(newBreak);
    setTimeout(() => setShowModal(false), 500);
  };

  return (
    <div className={styles.content}>
      <h2 className={styles.title}>Add Break</h2>
      <form className={styles.form} action="submit" onSubmit={handleOnSubmit}>
        <div className={styles.modalAddBreake}>
          <DropdownMenu
            className={styles.minBrake}
            fieldName={"min"}
            labelText={"Min"}
            data={dataBreaks}
            selectedMinDuration={selectedMinDuration}
            setSelectedMinDuration={setSelectedMinDuration}
          />
          <DropdownMenu
            className={styles.maxBrake}
            fieldName={"max"}
            labelText={"Max"}
            data={dataBreaks}
            selectedMaxDuration={selectedMaxDuration}
            setSelectedMaxDuration={setSelectedMaxDuration}
          />
        </div>

        <div className={styles.group}>
          <Button
            size={VIEW.MIDDLE}
            color={COLOR.LIGHT}
            onClick={() => setShowModal(false)}
          >
            Cancel
          </Button>
          <Button size={VIEW.MIDDLE} type="submit">
            {loading ? <Loading /> : "Save"}
          </Button>
        </div>
      </form>
    </div>
  );
};
